import { DomainDataType } from './../../../shared/service/domains/model/domain-data-type';
import { ContaIonService } from './../../../shared/service/domains/services/conta-ion.service';
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { RadioModel } from "../../../shared/model/radio.model";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { ValueSort } from "../../../shared/sort-funcions/value-sort";
import { PersonalDataService } from "../../service/personal-data.service";

@Component({
  selector: "app-expedition-state",
  templateUrl: "./expedition-state.component.html",
  styleUrls: ["./expedition-state.component.scss"],
})
export class ExpeditionStateComponent
  extends DefaultPageComponent
  implements OnInit
{
  selectedItem = "";
  selectedName = "";
  expeditionState = new Array<RadioModel>();
  textSearch: string;
  fieldSearch = "value";
  headerId = "expedition-state";
  titlePage = "Dados pessoais";
  buttonEnable = false;
  @ViewChild("content") content: ElementRef;
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  titleLabelPage = "Em que estado foi expedido?";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  idLabelExpeditionState = "labelExpeditionState";
  idInputSearchExpeditionState = "inputSearchExpeditionState";
  idRadioExpeditionState = "radioExpeditionState";
  idButtonExpeditionState = "buttonExpeditionState";
  idRetryExpeditionState = "retryExpeditionState";

  constructor(
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    public router: NavController,
    private personalDataService: PersonalDataService,
    public returnNativeService: ReturnNativeService,
    private title: Title,
    public analycticsNativeService: AnalycticsNativeService,
    private domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private service: ContaIonService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.State);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getDomainState();
    this.setTitleLabel();
    this.editFieldInvest(
      "documento_estado_expedicao_sigla",
      "expeditionState",
      "personalData"
    );
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "5";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  setTitleLabel() {
    const documentTypeName = this.formatTypeDocumentName(
      this.personalDataService.getDocumentTypeData()
    );
    if (documentTypeName) {
      const text = documentTypeName === "CNH" ? "sua" : "seu";
      const textFinal = documentTypeName === "CNH" ? "expedida" : "expedido";
      this.titleLabelPage = `Em que estado ${text} ${documentTypeName} foi ${textFinal}?`;
    }
  }

  formatTypeDocumentName(typeDocument: string) {
    switch (typeDocument) {
      case "551":
        return "RG";
      case "552":
        return "RNE";
      case "558":
        return "CNH";
      default:
        return "";
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.textSearch = "";
    this.expeditionState = this.orderList(
      this.expeditionState,
      this.selectedItem
    );
    this.ariaHidden = true;
  }

  scrollContentToTop() {
    setTimeout(() => this.content?.nativeElement.scrollTo(0, 0), 200);
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.documentExpeditionState;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathEstadoExpeditor,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    const paramComplementary = {
      detail: this.formatTypeDocumentName(
        this.personalDataService.getDocumentTypeData()
      ).toLowerCase(),
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathEstadoExpeditor,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    this.sendAnalyticsFirstView = true;
    this.personalDataService.setExpeditionStateName(this.selectedName);
    this.personalDataService.setExpeditionState(this.selectedItem);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.documentExpeditionState,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  async getDomainState() {
    try {
      const dominios = await this.chamadaEstado();
  
      if (dominios?.length > 0) {
        this.expeditionState = this.orderList(
          dominios,
          this.journeyService.registratioJourney.data.personalData?.expeditionState
        );
  
        const key = 'caronte_pix_conta_ion-state';
        localStorage.setItem(key, JSON.stringify(dominios));
  
        this.showRetry = false;
        this.analyticsData();
        this.sendTrackGA4LoadPage();
      } else {
        this.showRetry = true;
        this.loading = false;
        this.headerFocus();
        this.sendTrackGA4LoadPageError();
      }
    } catch (error) {
      this.showRetry = true;
      this.loading = false;
      this.sendTrackGA4LoadPageError();
    } finally {
      this.loading = false;
      this.headerFocus();
    }
  }

  orderList(data: RadioModel[], selectedItem: string): RadioModel[] {
    if (selectedItem !== "") {
      const dataOrder = data;
      dataOrder.sort(ValueSort.compareFn);
      return [
        ...dataOrder.filter((value) => value.key === selectedItem),
        ...dataOrder.filter((value) => value.key !== selectedItem),
      ];
    }
    return data;
  }

  getPageId(): string {
    return this.headerId;
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.personalData.expeditionState
    ) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.personalData.expeditionState;
      this.selectedName =
        this.journeyService.registratioJourney.data.personalData.expeditionStateName;
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  changeValue() {
    this.expeditionState = this.orderList(
      this.expeditionState,
      this.selectedItem
    );
  }

  private chamadaEstado(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.service.getRootDomains(DomainDataType.State)
        .subscribe({
          next: (response) => {
            console.log("response domain", response)
            if (response && response.length > 0) {
              resolve(response);
            } else {
              reject('Nenhum dado encontrado');
            }
          },
          error: (error) => {
            console.error('Erro ao obter os estados:', error);
            reject('Erro ao obter dados');
          }
        });
    });
  }
}
